<template>
  <div v-if="isVisible" id="com_pagetop1" @click="scrollToTop">
    <!-- ボタンの内容 -->
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted, ref } from "vue";

export default defineComponent({
  name: "BackToTop",
  setup() {
    const isVisible = ref(false);

    const handleScroll = () => {
      const windowHeight = window.innerHeight / 8;
      isVisible.value = window.scrollY > windowHeight;
    };

    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    onMounted(() => {
      window.addEventListener("scroll", handleScroll);
      window.addEventListener("load", handleScroll);
    });

    onUnmounted(() => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("load", handleScroll);
    });

    return {
      isVisible,
      scrollToTop,
    };
  },
});
</script>
